import React, { useState, useEffect } from 'react'
import { getData } from '../../../../actions/servicesHttp'
import { useParams } from 'react-router-dom'
import Header from '../../../../components/generals/header'
import ReturnButton from '../../../../components/generals/buttonReturn'
import stylesIndex from '../../../../css/Index.module.css'
import MenuHardware from '../../../../components/generals/menuHardware'
import Loading from '../../../../components/generals/loading'
import Memory from './components/memory'
import Bios from './components/bios'
import DiskDrive from './components/diskDrive'
import Processor from './components/processor'
import { useTranslation } from 'react-i18next'

export default function Hardware () {
  const { t } = useTranslation('hardware')
  const { id } = useParams()
  const [data, setData] = useState(null)

  const [componentShow, setComponentShow] = useState({
    physicalMemory: false,
    diskDrive: false,
    bios: false,
    processor: true
  })

  useEffect(() => {
    const getDataHardwareDevice = async () => {
      const { data } = await getData('device/hardware', id)
      if (data) {
        setData(data[0])
      } else {
        setData([])
      }
    }
    getDataHardwareDevice()
  }, [id])

  return (
         <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
            <div className={`content  ${stylesIndex.mainContent}`}>
                <Header title={t('title1')} />
                <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                  <ReturnButton redirect={`device/${id}`} />
                </div>
                {data === null && <Loading color="primary" />}
                {data !== null && <div style={{ marginTop: '1rem' }}>
                    <MenuHardware setComponentsModal={setComponentShow}/>
                    {componentShow?.physicalMemory && <Memory memoirs={data?.PhysicalMemory} />}
                    {componentShow?.bios && <Bios bios={data?.Bios[0]} />}
                    {componentShow?.diskDrive && <DiskDrive diskDrive={data?.DiskDrive} />}
                    {componentShow?.processor && <Processor processor={data?.Processor} />}
                </div>}
            </div>
      </div>
  )
}
